export const Cart = {
    ADD_ITEM_TO_WISHLIST :"cart/ADD_ITEM_TO_WISHLIST",
    DELETE_ITEM_WISHLIST:"cart/DELETE_ITEM_WISHLIST"
,    GET_CART:"cart/GET_CART",
    UPDATE_ITEM_CART:"cart/UPDATE_ITEM_CART",
    GET_WISHLIST: "cart/GET_WISHLIST"
}